import React, { Component } from 'react';
import store from '../store';
import { RESET_CITY, FILE_IMAGES, typeList, showTimeList, LBFormulaList, LBFormulaList2, answerTimeList, qCountList, maxNumberList, digitsList, YesNoList, typeCatList } from '../config/static';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import DoneIcon from '@material-ui/icons/Done';

import createHistory from 'history/createBrowserHistory';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';

import InputLabel from '@material-ui/core/InputLabel';
import ButtonBase from '@material-ui/core/ButtonBase';

import { Redirect } from 'react-router-dom';

import NumDisplay from "./NumDisplay"
import CountDown from "./CountDown"
import firebase from "firebase/app";
import "firebase/firestore";
import * as STATIC from '../config/static';
import _ from 'lodash'
import Modal from 'react-responsive-modal';
const DWIDTH = 480;
const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    backgroundImage: "url('assets/images/bg.jpg')",
    backgroundPosition: "center center",
    backgroundAttachment: "fixed",
    WebkitBackgroundSize: "cover",
    backgroundSize: "cover",
    overflow: 'hidden',
    position: 'absolute',
    display: 'table',
    height: '100%',
    width: '100%',
    color: '#1B5E20'
  },
  middle: {
    display: 'table-cell',
    verticalAlign: 'top',
    padding: "0 5px",
  },
  square: {
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: DWIDTH,
    padding: theme.spacing.unit * 2,
    borderRadius: '20px',
    backgroundColor: '#c5e0b5',
    marginTop: 5,
    marginBottom: 10
  },
  textField: {
    minWidth: 200,

  }, container: {
    maxWidth: "1170px",
    marginLeft: "auto",
    marginRight: "auto",
    padding: "10px"
  }, chips: {
    display: 'flex',
    flexWrap: 'wrap',

  },
  chip: {
    margin: 2,
    backgroundColor: '#538234',
    color: 'white'
  },
});

function numDigits(x) {
  return Math.max(Math.floor(Math.log10(Math.abs(x))), 0) + 1;
}
function isMobileDevice() {
  return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
};
function searchLabel(array, value) {
  let rel = '';
  let index = array.findIndex(a => a.value == value);
  if (index > -1) {
    rel = array[index].label;
  }
  return rel;
}
function isInt(n) { return parseInt(n) === n };
let _this;
class LessonComp extends Component {
  constructor(props) {
    super(props);
    _this = this;
    this.state = {
      type: props.type ? props.type : ['image'],
      rows: props.rows ? props.rows : 3,
      showTime: props.showTime ? props.showTime : 6,
      answerTime: props.answerTime ? props.answerTime : 6,
      qCount: props.qCount ? props.qCount : 5,
      maxNumber: props.maxNumber ? props.maxNumber : 10,
      digits: props.digits ? props.digits : 1,
      digits1: props.digits1 ? props.digits1 : 1,
      digits2: props.digits2 ? props.digits2 : 1,
      minDigits: props.minDigits ? props.minDigits : 1,
      maxDigits: props.maxDigits ? props.maxDigits : 3,
      roundNumber: props.roundNumber ? props.roundNumber : 0,
      largerThan: props.largerThan ? props.largerThan : 0,
      displaySetting: props.displaySetting ? props.displaySetting : 0,
      displayShow: props.displayShow ? props.displayShow : 1,
      lessThan0: props.lessThan0 ? props.lessThan0 : 0,
      isReversed: props.isReversed ? props.isReversed : 0,
      enableSound: props.enableSound ? props.enableSound : 0,
      point:props.point ? props.point : 0,
      point_r:props.point_r ? props.point_r : 0,
      point_pass:props.point_pass ? props.point_pass : 0,
      no_result:props.no_result ? props.no_result : 0,
      curType:props.curType ? props.curType : 'general',
      dr1: props.dr1 ? props.dr1 : 0,
      dr2: props.dr2 ? props.dr2 : 0,
      rfrom: props.rfrom ? props.rfrom : 0,
      rto: props.rto ? props.rto : 0,
      dba: props.dba ? props.dba : 1,
      wWidth: 0,
      wHeight: 0,
      answerInput: '',
      showEq: false,
      curIndex: 0,
      questions: [],
      showing: false,
      showCountDown: false,
      message: '',
      showSetting: false,
      starting: false, showEQMessage: '',
      showSetting2:false,
      curPoint:0,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  handleChange = name => event => {

    //event.preventDefault();
    console.log(event.target.value);
    this.setState({
      [name]: event.target.value

    });

  }
  handleChangeDigits = (name,max) => event => {

    let value = event.target.value;
    if(value>max)
    {
      value=max;
    }

    this.setState({
      [name]: value
    });

  }
  handleChangeNumber = (name,max,min) => event => {
    if(event.target.value>max||event.target.value<1||event.target.value<min)
    {
      return this.forceUpdate();
    }

    this.setState({
      [name]: event.target.value

    });

  }
  handleKeypress = event => {
    //console.log(event.key);
    if (event.key === "Enter") {
      _this.confirmAnswer();
    }
  }

  handleDelete = (name, value) => {
    let change = _this.state[name];

    change = _.without(change, value);

    this.setState({
      [name]: change
    });
  }

  componentDidMount() {
    //console.log('test',_this.getRandomFormula('LB_3'));
    // console.log('LB',this.checkLB(8,-5));


    _this.setState({sAudio:(new Audio("assets/sound/success.mp3")),fAudio:(new Audio("assets/sound/fail2.mp3")),yAudio:(new Audio("assets/sound/yay.mp3"))});

    //console.log(isMobileDevice());
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }


  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }


  async startLesson() {
    if (_this.state.processing == true) {
      return;
    }
    if (_this.state.starting == true) {
      if (_this.props.onLessonEnd) {
        _this.props.onLessonEnd(_this.state.questions);
      }
      _this.setState({ showCountDown: false, showing: false, message: '', answerInput: '', questions: [], starting: false, curIndex: 0 });

      return;
    }
    await _this.setState({processing:true});

    //console.log(_this.randomQuestionList(_this.state.qCount));
    let questions = _this.randomQuestionList(_this.state.qCount);

    // console.log(questions);
    // return;
    if (questions && questions.length > 0)
      {
        _this.remain = 0;
        _this.setState({ showCountDown: false, trial: false, questions, starting: true, curIndex: 0,curPoint:0, answerInput: '', message: '' }, () => this.progressQuestion());
      }
      await _this.setState({processing:false});
  }


  checkLB(t, value) {
    t=t%10;
    if (t > 0 && t < 5 && value > 0 && value < 5 && t + value >= 5 && t + value < 10) {
      return true;
    }
    if (t >= 5 && t < 10 && t + value > 0 && t + value < 5 && value > -5) {
      return true;
    }
    return false;
  }
  checkBB(t, value) {
    if (t > 0 && (t % 10) + value >= 10) {
      return true;
    }
    if (_this.state.lessThan0) {
      if (t >= 0 && t < 10 && t + value < 0) {
        return true;
      }
    }
    else {
      if (t >= 10 && (t % 10) + value < 0) {
        return true;
      }
    }

    return false;
  }

  getNumbersForLB(t, lbNumb = 0, last = false) {
    let index = -9;
    let relArr = [];
    //console.log(lbNumb);

    for (index; index < 10; index++) {

      if (last) {
        if (t + index >= 0) {
          relArr.push(index);
        }
        else
          continue;
      }
      if ((lbNumb > 0 && lbNumb < 5) || (lbNumb < 0 && lbNumb > -5)) {
        if (_this.checkLB(t + index, lbNumb)) {
          relArr.push(index);
        }
        else {
          continue;
        }
      }
      else {
        relArr.push(index);
      }



    }
    return relArr;
  }
  getNumbersList(t, lbNumb = 0, last = false, type = 'LB') {
    let index = -9;
    let relArr = [];
    //console.log(lbNumb);

    for (index; index < 10; index++) {

      if (last) {
        if (t + index >= 0) {
          relArr.push(index);
        }
        else
          continue;
      }
      if (type == "LB" && ((lbNumb > 0 && lbNumb < 5) || (lbNumb < 0 && lbNumb > -5))) {
        if (_this.checkLB(t + index, lbNumb)) {
          relArr.push(index);
        }
        else {
          continue;
        }
      }
      else
        if ((lbNumb > 0 && lbNumb < 10) || (lbNumb < 0 && lbNumb > -10)) {
          if (_this.checkBB(t + index, lbNumb)) {
            if (lbNumb > 5) {
              if (type == "BB") {
                if (!_this.checkLB(t + index, (-10 + lbNumb))) {
                  relArr.push(index);
                }
                else {
                  continue;
                }
              }
              else {
                //console.log(10-lbNumb);
                if (_this.checkLB(t + index, (-10 + lbNumb))) {
                  relArr.push(index);
                }
                else {
                  continue;
                }
              }
            }
            else if (lbNumb < -5) {
              if (type == "BB") {
                if (!_this.checkLB(t + index, (10 + lbNumb))) {
                  relArr.push(index);
                }
                else {
                  continue;
                }
              }
              else {
                //console.log(t+index,(10-lbNumb));
                if (_this.checkLB(t + index, (10 + lbNumb))) {
                  relArr.push(index);
                }
                else {
                  continue;
                }
              }
            }
            else {
              relArr.push(index);
            }
          }
          else {
            continue;
          }
        }

        else {
          relArr.push(index);
        }



    }
    return relArr;
  }


  getFormulaList(type) {
    let typeObject = _.find(typeList,{value:type});
    let index = LBFormulaList.findIndex(t=>t==typeObject.fvalue);
    if(_this.state.isReversed)
    {
      index = LBFormulaList2.findIndex(t=>t==typeObject.fvalue);
    }
    //console.log(type,index);
    let relArr = [];
    if (index > -1) {
      for (let nIndex = 0; nIndex <= index; nIndex++) {
        if(_this.state.isReversed)
        {
          relArr.push(LBFormulaList2[nIndex]);
        }
        else
        relArr.push(LBFormulaList[nIndex]);
      }
    }

    return relArr;
  }


  filterNumbersWithList(total, list, numbers) {
    let relArr = []
    for (let f of list) {
      let tArr = numbers.filter(n => {
        if (f == 0) {
          //  console.log('check',total,n,_this.checkLB(total,n));

          //return !_this.checkLB(total,n)&&!this.checkBB(total,n)&&total+n>=0&&n!=0;
          if (this.state.digits > 1)
            return !_this.checkLB(total, n) && !this.checkBB(total, n) && total + n >= 0;
          return !_this.checkLB(total, n) && !this.checkBB(total, n) && total + n >= 0 && n != 0;
        }
        else {
          if (f < 5 && f > -5 && isInt(f)) {

            return _this.checkLB(total, n) && n == f && !this.checkBB(total, n);
          }
          else {

            return _this.checkBB(total, n) && n == parseInt(f);
          }

        }
        return false;
      })

      relArr = _.union(relArr, tArr);
    }
    return relArr;
  }
  generateItemForLB2(item, lbNumb, type) {
    let { maxNumber, rows, digits, lessThan0,largerThan,roundNumber } = _this.state;
    item.result = _.random(maxNumber - 1);
    item.numbers = [];
    let total = 0;
    let nIndex = 0;
    let nTotal = [];

    let position = _.random(1, rows - 1);
    if ((type == "BB"||type == "L&B") && ((lessThan0 && lbNumb == -1) || (!lessThan0 && lbNumb < 0)))
      position = _.random(2, rows - 1);
    let vposition = _.random(0, digits - 1);
    if((type=='BB'||type=='L&B')&&largerThan==0)
    {
      if(digits>=2)
      vposition = _.random(0, digits - 2);
    }
    if(roundNumber==1)
    {
      largerThan = 1;
      vposition = digits-1;
    }


    //console.log("position",position,vposition);
    let fArray = [];
    for(let rIndex=0;rIndex<digits;rIndex++)
    {
      fArray.push([]);
      nTotal.push(0);
    }

    for (let tIndex = 0; tIndex < rows; tIndex++) {
      if (position == tIndex) {
        fArray[0].push(lbNumb);
      }
      else
        fArray[0].push(0);
        for(let rIndex=1;rIndex<digits;rIndex++)
        {
          fArray[rIndex].push(0);
        }
    }
    let formulaList = _this.getFormulaList(item.type);

    for (nIndex; nIndex < rows; nIndex++) {
      let rNumber = [];
      for(let rIndex=0;rIndex<digits;rIndex++)
      {
        rNumber.push(0);
      }

      let numbers = [];
      //let temp_nTotal = nTotal;
      let next = fArray[0][nIndex + 1] ? fArray[0][nIndex + 1] : 0;
      let next01=next;
      let next2 = fArray[0][nIndex + 2] ? fArray[0][nIndex + 2] : 0;
      let next02=next;
      let current = fArray[0][nIndex];
      //console.log(next,next2,next3);
      if (current != 0) {

        numbers = [current];

      }
      else {
        if (next != 0) {
          numbers = _this.getNumbersList(nTotal[0], next, 0, type)
        }
        else {
          if (nIndex == rows - 1) {
            numbers = _this.getNumbersList(nTotal[0], next, true, type)
          }
          else {
            numbers = _this.getNumbersList(nTotal[0], next, 0, type)
          }

        }
      }
      //console.log(1,numbers);
      numbers = _this.filterNumbersWithList(nTotal[0], formulaList, numbers);
      //console.log(2,numbers);
      numbers = numbers.filter(n => {
        let tnumbers = _this.getNumbersList(nTotal[0] + n, next2, 0, type);

        tnumbers = _this.filterNumbersWithList(nTotal[0] + n, formulaList, tnumbers);
        //console.log(tnumbers);
        return tnumbers.length > 0 ? true : false;
        //return nTotal+n<5&&nTotal+n>=0&&nTotal+n>=-4-next2;
      })

      if (nIndex == 0) {
        numbers = numbers.filter(n => n > 0);
      }
      if((type=='BB'||type=='L&B')&&largerThan==0)
      {
          if(vposition==digits-2)
          {
            //console.log(nIndex,1,next,nTotal[0],numbers);

            if(next2!=0||next!=0)
            {
              //console.log("next",next2,next);
              if((total>80&&next2!=0)||(total>90&&next!=0))
              {
              //  console.log('test',numbers,nTotal[0]);
                numbers = numbers.filter(n => n<=0);
              //  console.log('test',numbers,nTotal[0]);
              }
              else {
              //  console.log('test1',numbers,nTotal[0]);
                numbers = numbers.filter(n => total+n<=(next2!=0?80:90));
              //  console.log('test1',numbers,nTotal[0]);
              }

            }
            else {
              //  console.log('test12',numbers,nTotal[0]);
              numbers = numbers.filter(n => (nTotal[0]+n)+(nTotal[vposition+1])*10<100||n<=0);
              //console.log('test12',numbers,nTotal[0]);
            }

          //  console.log(nIndex,2,next,nTotal[0],numbers);
          }
      //  numbers = numbers.filter(n => nTotal[0]+n <20);
      }
      rNumber[0] = _.sample(numbers);
      nTotal[0] += rNumber[0];
      for(let rIndex=1;rIndex<digits;rIndex++)
      {
        if(roundNumber==1)
        {
          rNumber[rIndex] = 0;
          nTotal[rIndex] += 0;
          continue;
        }
        numbers=[];
        let next = 0;
        let next2 = 0;
        let current = fArray[rIndex][nIndex];
        if (current != 0) {

          numbers = [current];

        }
        else {
          if (next != 0) {
            numbers = _this.getNumbersForLB(nTotal[rIndex], next, 0, type)
          }
          else {
            if (nIndex == rows - 1) {
              numbers = _this.getNumbersForLB(nTotal[rIndex], next, true, type)
            }
            else {
              numbers = _this.getNumbersForLB(nTotal[rIndex], next, 0, type)
            }

          }
        }
        numbers = _this.filterNumbersWithList(nTotal[rIndex], formulaList, numbers);
        numbers = numbers.filter(n => {
          let rel = true;
          if(rNumber[0]>0)
          {
            if(n<0)
            rel=false
          }
          else if(rNumber[0]<0)
          {
            if(n>0)
            rel=false
          }
          // for(let rIndex2=1;rIndex2<=rIndex;rIndex++)
          // {
          //   if(rNumber[0]>0)
          //   {
          //     if(rNumber[rIndex]<0)
          //     rel=false;
          //   }
          //   else if(rNumber[0]<0)
          //   {
          //     if(rNumber[rIndex]>0)
          //     rel=false;
          //   }
          // }
          return rel;

        })
        numbers = numbers.filter(n => {
          let tnumbers = _this.getNumbersForLB(nTotal[rIndex] + n, next2, 0, type);
          tnumbers = _this.filterNumbersWithList(nTotal[rIndex] + n, formulaList, tnumbers);
          //console.log(tnumbers);
          return tnumbers.length > 0 ? true : false;
          //return nTotal+n<5&&nTotal+n>=0&&nTotal+n>=-4-next2;
        })

        if (nIndex == 0) {
          numbers = numbers.filter(n => n > 0);
        }
        if((type=='BB'||type=='L&B')&&largerThan==0&&digits==rIndex+1)
        {
          // if(vposition==rIndex-1)
          // {
          //  console.log(numbers,nTotal[rIndex-1],next01);
          if(next02!=0)
          {
          //  console.log("test2",numbers,rNumber[0]);
            numbers = numbers.filter(n => (nTotal[rIndex-1]+(nTotal[rIndex]+n)*10<80||n<=0));
            if(numbers.length>=2)
            {
              numbers = numbers.filter(n => n!=0);
            }
          //  console.log("test22",numbers);
          }
          else
          if(next01!=0)
          {
          //  console.log("test3",numbers,rNumber[0]);
            numbers = numbers.filter(n => (nTotal[rIndex-1]+(nTotal[rIndex]+n)*10<90||n<=0));
            if(numbers.length>=2)
            {
              numbers = numbers.filter(n => n!=0);
            }
          //  console.log("test32",numbers,rNumber[0]);
          }
          else
          {
            numbers = numbers.filter(n => (nTotal[rIndex-1]+next01+(nTotal[rIndex]+n)*10<100)||n<=0);
            if(numbers.length>=2)
            {
              numbers = numbers.filter(n => n!=0);
            }
          }

          //  console.log(numbers);
          //}
          //console.log('larger');
          // console.log("||||||||||||")
          // numbers = numbers.filter(n => {
          //   console.log(n,nTotal[rIndex-1],(nTotal[rIndex]+n)*10,nTotal[rIndex-1]+(nTotal[rIndex]+n)*10);
          //     console.log("-------")
          //   return nTotal[rIndex-1]+(nTotal[rIndex]+n)*10<100});
        //numbers = numbers.filter(n => nTotal[rIndex]+n <9);
        }
        rNumber[rIndex] = _.sample(numbers);
        nTotal[rIndex] += rNumber[rIndex];
      }

      // let temp_total=total-rNumber;
      // if(nIndex==rows-1)
      // {
      //   rNumber = total;
      // }
      // else
      // while(temp_total>=maxNumber||temp_total<=-maxNumber)
      // {
      //   rNumber = _.random(-maxNumber+1,maxNumber-1);
      //   temp_total=total-rNumber;
      // }
      // total=temp_total;
      let finalNumber = rNumber[0];

      if(digits>=2)
      {
        finalNumber = rNumber[0]*Math.pow(10,vposition);

        for(let rIndex=1;rIndex<digits;rIndex++)
        {
          if(rIndex-1<vposition)
          finalNumber += rNumber[rIndex]*Math.pow(10,rIndex-1);
          else {
            finalNumber += rNumber[rIndex]*Math.pow(10,rIndex);
          }
        }
      }


      if (finalNumber != undefined && !isNaN(finalNumber))
        item.numbers.push(finalNumber);
      else {
      //  console.log('undefined', nTotal);
        // item.numbers=[];
        // nIndex=-1;
        //  nTotal = 0;
        // nTotal2 = 0;
        return _this.generateItemForLB2(item,lbNumb,type);
      }
      total += finalNumber;
    }
    item.result = total;
    //  console.log(total);
  }



  randomQuestionList(number = 1) {

    let questions = [];
    let { rows, digits,digits1,digits2,roundNumber,dr1,dr2,dba,curType } = _this.state;

    if (rows < 3 || rows > 100) {
      alert("Rows need to be between 3 and 100");
      return;
    }
    let PlusType = ['LB_1','LB_2','LB_3','LB_4','LB_-1','LB_-2','LB_-3','LB_-4','BB_9.1','BB_8.1','BB_7.1','BB_6.1','BB_5.1','BB_4.1','BB_3.1','BB_2.1','BB_1.1','BB_-9.1','BB_-8.1','BB_-7.1','BB_-6.1','BB_-5.1','BB_-4.1','BB_-3.1','BB_-2.1','BB_-1.1'];
    let MultiType = ['multiple'];
    let DivideType = ['divide'];

    let index;
    for (index = 0; index < number; index++) {
      let item = { type: "multiple" };
      let type=PlusType;
      if(curType == 'plus'||(curType == 'general'&&index%3==0))
      {
        type = PlusType;
      }
      if(curType == 'multiple'||(curType == 'general'&&index%3==1))
      {
        type = MultiType;
      }
      if(curType == 'divide'||(curType == 'general'&&index%3==2))
      {
        type = DivideType;
      }
      if (type.length > 0) {
        item = { type: _.sample(type) };
      }
      if (item.type == "soroban") {
        item.result = _.random(Math.pow(10,digits-1),Math.pow(10,digits)-1);
      }

      else if (item.type == "image") {
        item.result = _.random(9);
        if(digits>1)
        {
          item.result = _.random(10,99);
          if(roundNumber)
          {
            item.result = _.random(1,9)*10;
          }
        }


        item.images = [];
        if (item.result >= 10) {
          item.images.push("assets/images/finger/" + Math.floor(item.result / 10) + "0-01.png");
        }
        if(item.result < 10||roundNumber==0||roundNumber==false)
        {
        item.images.push("assets/images/finger/" + item.result % 10 + "-01.png");
      }
      }
      else if(item.type=="multiple")
      {

        let d1 = _.random(Math.pow(10,digits1-1),Math.pow(10,digits1)-1);
        if(roundNumber)
        {
          d1 = _.random(1,9)*Math.pow(10,digits1-1);
        }
        let d2 = _.random(Math.pow(10,digits2-1),Math.pow(10,digits2)-1);
        if(roundNumber)
        {
          d2 = _.random(1,9)*Math.pow(10,digits2-1);
        }
        if(dr1!=0&&dr2!=0)
        {
          d2 = _.random(dr1,dr2);
        }

        item.numbers = [d1,"x"+d2];
         item.result = d1*d2;
      }
      else if(item.type=="divide")
      {
        let d1 = _.random(Math.pow(10,digits1-1),Math.pow(10,digits1)-1);
        if(roundNumber)
        {
          d1 = _.random(1,9)*Math.pow(10,digits1-1);
        }
        let d2 = _.random(Math.pow(10,digits2-1),Math.pow(10,digits2)-1);
        if(roundNumber)
        {
          d2 = _.random(1,9)*Math.pow(10,digits2-1);
        }
        if(dr1!=0&&dr2!=0)
        {
          d2 = _.random(dr1,dr2);
        }
        if(parseInt(dba)==1)
        {

            let index=1;
            let nList =[];
            while (index)
            {
              if(d2*index<Math.pow(10,digits1)-1)
              {
                if(d2*index >=Math.pow(10,digits1-1))
                nList.push(d2*index);
                index++;
              }
              else {
                break;
              }
            }
          d1=_.sample(nList);
        }

        item.numbers = [d1,"÷"+d2];
         item.result = d1/d2;
      }

      else {
        let type = item.type.split('_');
        if (type.length > 1) {
          let fDigit = parseInt(type[1]);
          let fType = type[0];
          // if(fType=="LB")
          // {
          _this.generateItemForLB2(item, fDigit, type[0]);
          //}
        }


      }
      item.reList = _this.randomResults(item.result);
      //console.log(item.numbers,item.result);
      questions.push(item);
    }
    return questions;
  }
  randomResults(result)
  {
    let digits = numDigits(result);
    let reList = [result];
    let {rfrom,rto} = _this.state;
    while(reList.length<_this.state.no_result)
    {
      let tRel  = _.random(Math.pow(10,digits-1),Math.pow(10,digits)-1);
      if(rfrom!=0&&rto!=0)
      {
        tRel  = _.random(rfrom,rto);
      }
      if(_.indexOf(reList,tRel)==-1)
      {
        reList.push(tRel);
      }
    }
    reList = _.shuffle(reList);
    return reList;
  }
  isShowEnd() {
    _this.remain = _this.state.answerTime;
    _this.setState({ showing: false, showCountDown: true });
    //console.log("start countdown");
  }
  endCountDown() {
    //console.log("end coutdown");
    _this.confirmAnswer();
  }
  progressQuestion() {
    let q = _this.state.questions[_this.state.curIndex];
    if (q.type == "image"||q.type=="soroban") {
      _this.setState({ showCountDown: true });
    }
    else {
      _this.setState({ showCountDown: false, showing: true });
    }
  }

  confirmAnswer() {
    if (!_this.state.starting)
      return;
    let {curPoint,point} = _this.state;
    let q = _this.state.questions[_this.state.curIndex];
    let answer = _this.state.answerInput;
    if (q.result == parseInt(answer)) {
      q.status = 1;
      curPoint += parseInt(point);
      curPoint+=parseInt(_this.remain)*parseInt(_this.state.point_r);
    }
    else {
      q.status = 0;
    }
    q.answer = answer;
    let message = (<span style={{ color: "#fff8ad", fontSize: '10rem' }}><DoneIcon style={{ fontSize: '10rem' }} /></span>);
    if (q.status == 0) {
      message = (<span style={{ color: "red", fontSize: '10rem' }}>X</span>);
      if(store.getState().SOUND==1)
      {
        _this.state.fAudio.currentTime=0;
  _this.state.fAudio.play();
      }
    }
    else {
      if(store.getState().SOUND==1)
      {
      _this.state.sAudio.currentTime=0;
_this.state.sAudio.play();
}
    }

    _this.setState({ showCountDown: false, message,curPoint, answerInput: '' });
    let curIndex = _this.state.curIndex;
    if (curIndex < _this.state.questions.length - 1)
      setTimeout(function() {
        _this.setState({ curIndex: curIndex + 1, answerInput: '', message: '' }, () => _this.progressQuestion());
      }, 2000);
    else {
      if (_this.state.starting) {
        message = (<span style={{ color: "#fff8ad", fontSize: '5rem' }}>Bravo!!</span>);
        if(store.getState().SOUND==1&&!_this.state.trial)
        {
          _this.state.yAudio.currentTime=0;
    _this.state.yAudio.play();
        }
        setTimeout(function() {
          _this.setState({ message, answerInput: '', starting: false });
          if (_this.props.onLessonEnd && !_this.state.trial) {
            _this.state.questions.curPoint = curPoint;
            _this.state.questions.point_pass = _this.state.point_pass;
            _this.props.onLessonEnd(_this.state.questions);
          }
        }, 2000);
      }
      else {
        setTimeout(function() {
          _this.setState({ message: '', answerInput: '', questions: [] });
        }, 2000);
      }


    }


  }


  updateEQMessage(index) {
    //_this.setState({ showEQMessage: _this.getShowEQ(index) })
  }
  generateResults(reList,width)
  {

    let rels = [];
    for(let item of reList)
    {


      rels.push(<Grid key={'rel'+item} item  style={{ textAlign: "right", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center',marginLeft:STATIC.calSize(10, STATIC.DWIDTH, width) }}>
           <Button onClick={() => _this.setState({answerInput:item},()=>_this.confirmAnswer())} style={{ color: "#053f22", padding: (STATIC.calSize(8, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(24, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', float: "right", fontSize: width * 0.06 }} color="primary" size="medium" variant="contained" >
            {item}
          </Button>
        </Grid>)

    }

    return rels;
  }
  onUpdateRemain(remain)
  {
    _this.remain = remain;
  }

  render() {
    const { classes,t } = this.props;
    const { wWidth, wHeight , showTime, answerTime, showing, questions, curIndex, message, starting, showCountDown,curPoint } = this.state;
    let width = DWIDTH - 10;
    if (wWidth < DWIDTH) {
      width = wWidth - 10;
    }

    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;

    //console.log("display",displaySetting);
    //console.log(width);

    return (



      <div>
        <Grid container direction="row" justify="center" style={{ marginTop: 5 }}>
          {questions.length > 0 ? <Grid item xs={6} >
            <p style={{ display: 'inline-block', color: 'rgb(5, 63, 34)', margin: 0, fontSize: fTitle, textAlign: 'center', width: "100%", borderRadius: "4px" }}>{curIndex + 1 + '/' + questions.length} sentence</p>
          </Grid> : false}
          {questions.length > 0 ? <Grid item xs={6} >
            <p style={{ display: 'inline-block', color: 'rgb(5, 63, 34)', margin: 0, fontSize: fTitle, textAlign: 'center', width: "100%", borderRadius: "4px" }}>Point: {curPoint}</p>
          </Grid> : false}
          <Grid item xs={12}  >
            <Grid container alignItems="center" justify="center" style={{ border: 2, borderRadius: 10, width: '100%', height: width * 0.8, backgroundColor: "#65a343", position: 'relative' }} >
              <div style={{ position: 'absolute', width: '100%', top: STATIC.calSize(5, STATIC.DWIDTH, width), left: STATIC.calSize(5, STATIC.DWIDTH, width) }}>
                <img
                  src="assets/web/logo_trans.png"
                  style={{ maxWidth: 296, height: 'auto', width: STATIC.calSize(160, STATIC.DWIDTH, width) }} />
              </div>


              {message ? <Grid item >
                {message}
              </Grid> :
                questions.length > 0 ?  <Grid item ><NumDisplay width={width} type={questions[curIndex].type} second={showTime} sound={false} numbers={questions[curIndex].numbers} showing={showing} updateEQMessage={this.updateEQMessage} isEnd={this.isShowEnd} /></Grid>  : false}

            </Grid>

          </Grid>
          <Grid item xs={12} style={{ marginTop: STATIC.calSize(10, STATIC.DWIDTH, width),marginBottom: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
            <Grid container direction="row" alignItems="center" justify="center">


              <Grid container direction="row" justify={'center'}>

                {showCountDown ? <Grid container alignItems="center" justify="center"><Grid item style={{ color: 'rgb(5, 63, 34)', fontSize: fNormal }}>
                  {t('common.remain_time')}: <CountDown size={fNormal} second={answerTime} onUpdateRemain={this.onUpdateRemain} isEnd={this.endCountDown} />
                </Grid></Grid> : false}

                {!starting ?<Grid item  style={{ textAlign: "right", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center',alignSelf:'center' }}>
                   <Button style={{ color: "#053f22", padding: (STATIC.calSize(8, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(24, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', float: "right", fontSize: fLarge }} color="primary" size="medium" variant="contained" onClick={() => this.startLesson()}>
                    {t('common.start')}
                  </Button>
                </Grid> : !showing?this.generateResults(questions[curIndex].reList,width):false}

              </Grid>

            </Grid>
          </Grid>
        </Grid>
      </div>


    );
  }
}

LessonComp.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(STATIC.translate('common')(LessonComp));
